import axios from "axios";
import { groundApi as defaultGroundApi } from "@b2bportal/ground-api";

export const carsApi = defaultGroundApi(axios);
